import React from "react";
import { injectIntl } from "react-intl";
import withStyles from "isomorphic-style-loader/withStyles";
import cx from "classnames";
import { useDispatch, useSelector } from "react-redux";
import { change, formValueSelector } from "redux-form";
import PriceSplitUp from "./PriceSplitUp/PriceSplitUp";
import PaymentMethod from "./PaymentMethod/PaymentMethod";
import CommonModal from "../../Modal/CommonModal";
import PromoCodeForm from "../../PromoCodeForm/PromoCodeForm";
import { closeHeaderModal, openHeaderModal } from "../../../actions/siteadmin/modalActions";
import { getOrderAction } from "../../../actions/order/getOrderAction";
import messages from "../../../locale/messages";
import getPaymentMethod from "./getPaymentMethod.graphql";
import getPromoCodes from "./getPromoCodes.graphql";
import { getAllPaymentMethodsQuery } from "../../../lib/graphql";
import useQueryResponse from "../../../lib/hooks/useQueryResponse";
import promoCodeIcon from '../../../../public/dashboard/promoCodeIcon.svg';
import promoArrowIcon from '../../../../public/dashboard/promoArrowIcon.svg';
import promoDeleteIcon from '/public/dashboard/promoDeleteIcon.svg';
import defaultPromoCodeAppliedIcon from '../../../../public/Icons/defaultPromoCodeAppliedIcon.svg'
import bt from '../../commonStyle.css';
import s from './PriceDetails.css';



const PriceDetails = (props) => {

    const { data, isOrderPage, intl: { formatMessage }, promoCodeValues } = props
    const { data: userPaymentMethod, loading } = useQueryResponse({
        query: getPaymentMethod,
        ssr: true,
        fetchPolicy: 'network-only'
    })
    const { data: paymentMethods, loading: paymentMethodLoading } = useQueryResponse({
        query: getAllPaymentMethodsQuery,
        ssr: true,
        fetchPolicy: 'network-only'
    })
    const { data: getAllPromoCode, loading: promoCodeLoading } = useQueryResponse({
        query: getPromoCodes,
        ssr: true,
        fetchPolicy: 'network-only'
    })
    let promoCodeInitialValues = {}

    if (!promoCodeLoading && getAllPromoCode?.getPromoCodes?.results && promoCodeValues) {
        const matchedPromo = getAllPromoCode?.getPromoCodes?.results?.find((promo) => promo.id === promoCodeValues.promoId);
        promoCodeInitialValues = {
            promoCode: matchedPromo?.code,
            promoId: matchedPromo?.id,
            validPromoCode: matchedPromo?.code,
        }
    }

    const promoCodeModal = useSelector(state => state?.adminModalStatus?.promoCodeModal)
    const selector = formValueSelector('PromoCodeForm')
    const validPromoCode = useSelector(state => selector(state, 'validPromoCode'))
    const dispatch = useDispatch()

    const closePromoCodeModal = () => {
        dispatch(closeHeaderModal("promoCodeModal"))
        if (!data?.result?.specialServiceFare) {
            dispatch(change('PromoCodeForm', 'promoCode', null));
            dispatch(change('PromoCodeForm', 'promoId', null));
        }
    }

    const handleRemove = () => {
        let isPromoIdRemove = true;
        dispatch(getOrderAction({ isPromoIdRemove }));
    }

    let categoryName, serviceFee, total, subTotal, visitFee, discount, currency, orderId;
    categoryName = data.result.categoryDetails.name
    serviceFee = data?.result?.userServiceFee;
    visitFee = data?.result?.travellingPrice;
    total = data?.result?.userPayableFare;
    subTotal = data?.result?.subTotal;
    discount = data?.result?.specialServiceFare;
    currency = data?.result?.currency;
    orderId = data?.result?.id;
    let initialValues = {}

    const enabledPaymentMethods =
        paymentMethods?.getAllPaymentMethods?.results?.filter(
            method => method.isEnable && method.paymentType !== 4
        ) || [];
    const isUserPaymentMethodEnabled = enabledPaymentMethods?.some(
        method => method.paymentType === userPaymentMethod?.getPaymentMethod?.result?.preferredPaymentMethod
    );
    if (!loading) {
        if (isUserPaymentMethodEnabled) {
            initialValues = { paymentMethodId: userPaymentMethod?.getPaymentMethod?.result?.preferredPaymentMethod }
        } else if (enabledPaymentMethods?.length > 0) {
            initialValues = { paymentMethodId: enabledPaymentMethods[0].paymentType };
        } else {
            initialValues = { paymentMethodId: '' };
        }

    }

    return (
        <>
            <CommonModal
                title={formatMessage(messages.promoCode)}
                onHide={closePromoCodeModal}
                modalStatus={promoCodeModal}
            >
                <PromoCodeForm promoCodeData={getAllPromoCode} initialValues={{ isPromoIdRemove: false }} />
            </CommonModal>
            <PriceSplitUp
                data={data}
                categoryName={categoryName}
                serviceFee={serviceFee}
                visitFee={visitFee}
                total={total}
                subTotal={subTotal}
                discount={discount}
                currency={currency}
                isOrderPage={isOrderPage}
                isTopRadius={true}
            />
            <div className={cx(bt.commonViewBookingRsBox, bt.spaceTop1, bt.space1)}>
                {
                    !discount && <div onClick={() => dispatch(openHeaderModal('promoCodeModal'))} className={cx(s.priceDetailsFlex, 'svgImg', s.cursorPointer)}>
                        <div className={s.promoCodeLsInfo}>
                            <img src={promoCodeIcon} alt="promoCodeIcon" />
                            <span className={cx(bt.commonSize16, bt.fontWeight400, bt.primaryColor)}>{formatMessage(messages.promoCode)}</span>
                        </div>
                        <img src={promoArrowIcon} alt="promoArrowIcon" className={cx('iconRotate')} />
                    </div>
                }
                {
                    discount > 0 && <div className={cx(s.priceDetailsFlex, 'svgImg', s.cursorPointer)}>
                        <div onClick={() => dispatch(openHeaderModal('promoCodeModal'))} className={s.promoCodeLsInfo}>
                            <img src={defaultPromoCodeAppliedIcon} alt="defaultPromoCodeAppliedIcon" />
                            <span className={cx(bt.commonSize16, bt.fontWeight400, bt.primaryColor)}>
                                <span className={bt.displayInlineBlock}>{promoCodeInitialValues?.validPromoCode ? promoCodeInitialValues?.validPromoCode : (validPromoCode ? validPromoCode : '')}&nbsp;</span>
                                <span className={cx(bt.discountForeground)}>{formatMessage(messages.applied)}</span>
                            </span>
                        </div>
                        <img src={promoDeleteIcon} alt="promoDeleteIcon" onClick={() => handleRemove()} className={cx('iconRotate')} />
                    </div>
                }
            </div>
            {
                !loading && <PaymentMethod initialValues={initialValues} userPaymentMethod={userPaymentMethod} orderId={orderId} />
            }

        </>
    )
}

export default injectIntl(withStyles(bt, s)(PriceDetails));
